import "css!js/file_viewer/file_viewer.module.out.css";
export const fvsdkMountPoint = "_fvsdk-mount-point_2087j_1";
export const fullScreenPreview = "_fullScreenPreview_2087j_6";
export const fileViewerArea = "_fileViewerArea_2087j_17";
const classes = { "fvsdkMountPoint": "_fvsdk-mount-point_2087j_1", "fullScreenPreview": "_fullScreenPreview_2087j_6", "fileViewerArea": "_fileViewerArea_2087j_17" };
export default classes;
//# sourceMappingURL=file_viewer.module.css.preenvesnextjs.map
